import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { IntegrationType } from '../../types/integration-type';
import { NsvaNetworkSensorView } from '../../sensors/nsva/view/NsvaNetworkSensorView';
import { MobileSecuritySensorView } from '../../sensors/mobileSecurity/view/MobileSecuritySensorView';
import { INTEGRATION_VIEW_BY_TYPE_MAP } from '../../types/integration-data';

export class IntegrationInformationWebView extends BaseWebComponentView {
  public dom: {
    $title: HTMLElement;
    $checklistArea: HTMLElement;
  };

  getDomElements() {
    this.dom = {
      $title: this.shadow.querySelector('#information-title'),
      $checklistArea: this.shadow.querySelector('#integration_information-checklist'),
    };

    this.getTranslations();
  }

  buildView() {
    this.buildSuccessView();
  }

  buildSuccessView(): void {}

  public addIntegrationSpecificRequirements(integrationType: IntegrationType) {
    if (!this.isConnected) {
      return;
    }
    const sensorView = INTEGRATION_VIEW_BY_TYPE_MAP[integrationType];
    if (sensorView) {
      this.dom.$checklistArea.innerHTML = sensorView.getRequirements(this.dependencies);
    }
  }
}
